module.exports = __webpack_public_path__ + "media/images/favorite-default-f98cd117979b28129aac22252fca4598.svg";